import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate, useLocation } from "react-router-dom";
import { getLeftNavRoutes, getRightNavRoutes } from "../router";
import headerBg from "@/assets/img/header/headerBg.png";
import { useEffect, useRef } from "react";
import { useState } from "react";
// 图片导入添加类型定义
import HeaderItemIcon from "@/assets/img/header/headerItemIcon.png";
import HeaderItemSelectIcon from "@/assets/img/header/headerItemSelectIcon.webp";
export default function Header({ onToggleFullscreen }) {
    const navigate = useNavigate();
    const location = useLocation();
    const [bgImage, setBgImage] = useState(headerBg);
    const [isAutoNavEnabled, setIsAutoNavEnabled] = useState(false);
    const timerRef = useRef(null);
    // 合并左右路由
    const leftTabs = getLeftNavRoutes();
    const rightTabs = getRightNavRoutes();
    const allTabs = [...leftTabs, ...rightTabs];
    // 处理背景图加载失败
    const handleBgError = () => {
        // 可以添加备用图片
        // setBgImage(headerBgFallback);
    };
    // 停止自动跳转
    const stopAutoNavigation = () => {
        setIsAutoNavEnabled(false);
        if (timerRef.current) {
            clearTimeout(timerRef.current);
            timerRef.current = null;
        }
    };
    // 重新开始自动跳转
    const restartAutoNavigation = () => {
        setIsAutoNavEnabled(true);
    };
    // 自动跳转逻辑
    useEffect(() => {
        if (!isAutoNavEnabled)
            return;
        const currentIndex = allTabs.findIndex((item) => item.path === location.pathname);
        if (currentIndex === -1)
            return;
        // 清除之前的定时器
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        // 设置新的定时器
        timerRef.current = setTimeout(() => {
            const nextIndex = currentIndex === allTabs.length - 1 ? 0 : currentIndex + 1;
            navigate(allTabs[nextIndex].path);
        }, 15000); //30S 切换
        // 清理函数
        return () => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [location.pathname, allTabs, navigate, isAutoNavEnabled]);
    // Tab按钮组件
    const TabButton = ({ item, index, isLeft, }) => {
        const isActive = location.pathname === item.path;
        const handleTabClick = (e) => {
            e.stopPropagation();
            stopAutoNavigation();
            navigate(item.path);
        };
        return (_jsx("div", { className: "relative", children: _jsxs("button", { onClick: handleTabClick, className: "relative flex items-center justify-center w-[1.61rem] h-[0.39rem] font-medium cursor-pointer bg-transparent border-none", title: item.description || item.name, children: [isActive ? (_jsx("img", { src: HeaderItemSelectIcon, alt: "\u9009\u4E2D\u72B6\u6001\u56FE\u6807", className: "absolute inset-0 ", style: {
                            width: "1.61rem",
                            height: "0.49rem",
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                            transform: isLeft ? "none" : "scaleX(-1)",
                        }, onError: handleBgError })) : (_jsx("img", { src: HeaderItemIcon, alt: "\u9ED8\u8BA4\u72B6\u6001\u56FE\u6807", className: "absolute inset-0", style: {
                            width: "1.61rem",
                            height: "0.49rem",
                            maxWidth: "100%",
                            maxHeight: "100%",
                            objectFit: "contain",
                            transform: isLeft ? "none" : "scaleX(-1)",
                        }, onError: handleBgError })), _jsx("span", { className: `
              relative z-10 text-white text-[0.15rem] leading-[0.15rem] font-bold
              w-[0.64rem] h-[0.15rem] overflow-hidden text-ellipsis whitespace-nowrap
              font-[\"Source Han Sans CN\", sans-serif]
              ${isActive ? "text-white" : "text-gray-200 hover:text-white"}
            `, children: item.name })] }) }));
    };
    // 阻止事件冒泡
    const handleOtherAreaClick = (e) => {
        e.stopPropagation();
    };
    return (_jsxs("header", { className: "relative h-[0.98rem] overflow-hidden", onDoubleClick: restartAutoNavigation, children: [_jsx("div", { className: "absolute inset-0 z-0", style: {
                    backgroundImage: `url(${bgImage})`,
                    backgroundSize: "100% 100%",
                    backgroundPosition: "center ",
                    backgroundRepeat: "no-repeat",
                }, onClick: handleOtherAreaClick }), _jsxs("div", { className: "relative z-20 h-full flex items-center ", onClick: handleOtherAreaClick, children: [_jsx("div", { className: "flex-1 h-full", children: _jsx("div", { className: "flex h-full justify-end items-end space-x-[0.02rem]", children: leftTabs.map((item, index) => (_jsx(TabButton, { item: item, index: index, isLeft: true }, item.path))) }) }), _jsxs("div", { className: "flex-shrink-0 w-auto flex flex-col justify-center px-[1.2rem]" //
                        , onClick: handleOtherAreaClick, style: { maxHeight: "0.98rem" }, children: [_jsx("span", { className: "bg-clip-text text-transparent tracking-widest mb-[0.08rem]", style: {
                                    fontFamily: "SourceHanSansSC",
                                    fontWeight: "bold",
                                    fontSize: "0.32rem", // 适当减小主标题字体
                                    background: "linear-gradient(180deg, #98CFFA 0%, #FFFFFF 50%, #98CFFA 100%)",
                                    WebkitBackgroundClip: "text",
                                    WebkitTextFillColor: "transparent",
                                    display: "inline-block",
                                    textAlign: "center",
                                }, children: "\u79D1\u7814\u8D44\u4EA7\u667A\u80FD\u7BA1\u7406\u5E73\u53F0" }), _jsx("span", { className: "block  text-[0.13rem] font-normal italic text-[#01F7DD] w-auto mx-auto leading-tight", children: "INTELLIGENT MANAGEMENT PLATFORM FOR SCIENTIFIC RESEARCH ASSETS" })] }), _jsx("div", { className: "flex-1 h-full", children: _jsx("div", { className: "flex h-full justify-start items-end space-x-[0.02rem]", children: rightTabs.map((item, index) => (_jsx(TabButton, { item: item, index: index, isLeft: false }, item.path))) }) })] })] }));
}
